import normalizeRoleRecord from '@/lib/settings/rolePermissions/normalizeRoleRecord.js';
import { toSafeString } from '@shared/utils';

const normalizeRoleCollection = ({ roles = [], activeCompanyId } = {}) => {
  const safeCompanyId = toSafeString(activeCompanyId);
  const roleItems = (Array.isArray(roles) ? roles : [])
    .map((role) => {
      return normalizeRoleRecord(role);
    })
    .filter((role) => {
      return Boolean(role.id);
    })
    .sort((left, right) => {
      const leftName = toSafeString(left?.name).toLowerCase();
      const rightName = toSafeString(right?.name).toLowerCase();

      if (leftName === rightName) {
        return toSafeString(left?.id).localeCompare(toSafeString(right?.id));
      }

      return leftName.localeCompare(rightName);
    });

  const builtInRoles = roleItems.filter((role) => role.isBuiltIn);
  const customRoles = roleItems.filter((role) => toSafeString(role?.companyId) === safeCompanyId);

  return {
    all: roleItems,
    builtIn: builtInRoles,
    custom: customRoles
  };
};

export default normalizeRoleCollection;
